/**
 * The scoreboard for a match that is on this phone: what the server last said, plus the balls
 * scored here that have not been sent.
 *
 * A saved copy of the server's ledger is, by construction, behind the phone whenever the scorer
 * has been offline — which is exactly when they look at the scoreboard. Showing the server's
 * last copy would show a score that is several overs old on the device holding the real one.
 *
 * The phone's copy of a ball wins over the server's: an unsent ball can only have been renumbered
 * here (`seq_conflict` is answered locally), so the local one is the later truth.
 */
import type { Event } from "@sportsos/engine";
import type { StoredEvent } from "@sportsos/sync";

export function mergeLedger(server: readonly Event[], local: readonly StoredEvent[]): Event[] {
  if (local.length === 0) return [...server];
  const byId = new Map<string, Event>(server.map((event) => [event.eventId, event]));
  for (const { event } of local) byId.set(event.eventId, event);
  return [...byId.values()];
}
